module.exports = __webpack_public_path__ + "cedc1f8a9ece73db4f325d9ecf265e5d.MP3";